import cx from 'classnames';
import Button from 'components/button/Button';
import Input from 'components/input/Input';
import Typography from 'components/typography/Typography';
import { TYPOGRAPHY_VARIANTS } from 'components/typography/typography-utils';
import { I18nNamespace } from 'constants/i18n.const';
import { useTranslation } from 'hooks/useTranslation';
import React, { memo, useState } from 'react';
import { useCheckPinCodeApiActionMutation } from 'store/api/booth.slice-api';
import { setSelfeAppStateAction } from 'store/features/app/selfeAppSlice';
import { useAppDispatch } from 'store/store-hooks';
import './keyboard-drawer.css';
import {
  PINCODE_STATUS,
  PINCODE_STATUS_MESSAGE_MAPPING,
} from 'models/photo/transaction.model';

export enum KeyboardHandleTypes {
  VOUCHER = 'VOUCHER',
  BOOTH_PIN = 'BOOTH_PIN',
}

export type PinCodePopupContentDrawerProps =
  React.HTMLAttributes<HTMLDivElement> & {
    onClose?: () => void;
    paymentMethod: number;
  };

const PinCodePopupContent: React.FC<PinCodePopupContentDrawerProps> = ({
  onClose,
  paymentMethod,
}) => {
  const dispatch = useAppDispatch();
  const { T } = useTranslation([I18nNamespace.COMMON, I18nNamespace.PAGE]);
  const [checkPinCodeApiAction] = useCheckPinCodeApiActionMutation();

  const [code, setCode] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isApplyingCode, setIsApplyingCode] = useState<boolean>(false);

  const handleOnChange = (code: string) => {
    setErrorMessage?.('');
    setCode(code);
  };

  const handleSubmit = async () => {
    if (!code) return;

    setIsApplyingCode(true);
    setErrorMessage('');

    const res: any = await checkPinCodeApiAction({
      pinCode: code,
      paymentMethod,
    });

    setIsApplyingCode(false);
    if (res && res?.data) {
      dispatch(
        setSelfeAppStateAction({
          isChooseQRCodeToPay: false,
          paymentMethodForTest: paymentMethod,
          pinCode: code,
        }),
      );
      onClose?.();
    } else {
      const errorCode = res?.error?.data?.code as PINCODE_STATUS;
      setErrorMessage(
        T(PINCODE_STATUS_MESSAGE_MAPPING[errorCode]) ||
          T(`${I18nNamespace.COMMON}:commonError`),
      );
    }
  };

  return (
    <div className="pin-code-popup-content">
      <br />
      <br />
      <Input
        type="password"
        placeholder={T(`${I18nNamespace.COMMON}:enterPIN`) as string}
        maxLength={6}
        pattern="[0-9]*"
        inputMode="numeric"
        onInput={(e) => {
          const input = e.target as HTMLInputElement;
          input.value = input.value.replace(/[^0-9]/g, '');
          handleOnChange?.(input.value);
        }}
        className="input-pin"
        variantFill
      />
      {!!errorMessage && (
        <Typography
          className="pin-code-error-text"
          variant={TYPOGRAPHY_VARIANTS.BODY}
          firstCapCase
          isError
        >
          {errorMessage}
        </Typography>
      )}
      <div className={cx('pb-popup-actions')}>
        <Button color="secondary" onClick={onClose}>
          {T('common:back')}
        </Button>
        <Button
          onClick={handleSubmit}
          disabled={isApplyingCode}
          loading={isApplyingCode}
        >
          {T('common:continue')}
        </Button>
      </div>
    </div>
  );
};

export default memo(PinCodePopupContent);
